import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "introduction",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#introduction",
        "aria-label": "introduction permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Introduction`}</h1>
    <p><img parentName="p" {...{
        "src": "./banner.png",
        "alt": "Learn TypeScript"
      }}></img></p>
    <p><strong parentName="p">{`Welcome to Learn TypeScript`}</strong>{`. My name is Carl Rippon, and I'm excited to bring you this course!`}</p>
    <p>{`If you are a JavaScript developer and want to build your apps faster and more robustly, this course is for you. Learn to use `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/"
      }}>{`TypeScript's amazing type system`}</a>{` with your existing JavaScript skills to boost your productivity, and create apps that are easier to maintain.`}</p>
    <p>{`The course assumes no prior knowledge of TypeScript and starts by helping you understand `}<a parentName="p" {...{
        "href": "./01/l1-what-is-ts"
      }}>{`what TypeScript is`}</a>{` and the benefits it brings. The course then gently introduces you to the `}<a parentName="p" {...{
        "href": "./02/l1-js-types"
      }}>{`TypeScript type system`}</a>{` and `}<a parentName="p" {...{
        "href": "./04/l2-objects"
      }}>{`how to create basic types`}</a>{`.`}</p>
    <p>{`You will eventually learn to `}<a parentName="p" {...{
        "href": "./06/l2-generic-functions"
      }}>{`create reusable types`}</a>{` that can be used in many situations reducing the code you need to write to produce flexible and strongly-typed code.`}</p>
    <p>{`The course then moves into more advanced topics such as `}<a parentName="p" {...{
        "href": "./07/l3-typeof-type-guard"
      }}>{`type narrowing`}</a>{`, `}<a parentName="p" {...{
        "href": "./10/l1-readonly-modifier"
      }}>{`immutable types`}</a>{`, `}<a parentName="p" {...{
        "href": "./08/l3-mapped-type"
      }}>{`mapped types`}</a>{` and `}<a parentName="p" {...{
        "href": "./09/l1-conditional-type"
      }}>{`conditional types`}</a>{` which will help you create your own powerful utility types.`}</p>
    <p>{`You will gain a deep understanding of the TypeScript `}<a parentName="p" {...{
        "href": "./11/l6-strictness"
      }}>{`compiler options`}</a>{` and use TypeScript with `}<a parentName="p" {...{
        "href": "./12/l2-babel"
      }}>{`Babel`}</a>{`, `}<a parentName="p" {...{
        "href": "./12/l3-eslint"
      }}>{`ESLint`}</a>{`, and `}<a parentName="p" {...{
        "href": "./12/l4-webpack"
      }}>{`Webpack`}</a>{` to produce a high quality codebase.`}</p>
    <p>{`TypeScript is one of the most loved languages at the moment and a must-know language that will serve you well for years to come.`}</p>
    <p>{`I hope you enjoy the course!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      